import { Box, Typography, Paper } from "@mui/material";
import { Avatar } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import DoneIcon from '@mui/icons-material/Done';
import FlagIcon from '@mui/icons-material/Flag';
import BlockIcon from '@mui/icons-material/Block';
import { apiUrlPrefix } from "../../../../config";
import React, { useState } from "react";
import getPrettyDate from "../../helper-methods/Dates/getPrettyDate";
import DeleteIcon from '@mui/icons-material/Delete';
import Linkify from 'react-linkify';
import ChatImage from "./ChatImage";

const ChatMessage = ({ emotionStyles, chatId, communityId, messages, userList, setMessages, chatAdmins }) => {
  const currentUser = localStorage.getItem('userId');
  const [reportedMessageIds, setReportedMessageIds] = useState([]);
  const [adminReportedMessageIds, setAdminReportedMessageIds] = useState();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //Reporting messages functionality
  const blockUser = async ({ reportedUserId }) => {
    const currentUId = currentUser;
    const apiUrl = apiUrlPrefix + 'Blocking/BlockUser';
    const response = await fetch(apiUrl, {
      method: 'PUT',
      credentials: 'include', // Include cookies in request
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId: currentUId,
        blockedUserId: reportedUserId
      }),
    });

    if (!response.ok) {
      if (response.status === 403) {
        //setErrorMessage('Invalid details. Ensure you add a Discussion title and at least 1 other user');
        return;
      }
      //setErrorMessage('Something went wrong. Please try again.');
      return;
    }
    return response.status; // Returns the report was sent
  };

  //Reporting messages functionality
  const createReport = async ({ reportedUser, reportedUserId, reportedMessage, reportLevel, reportStatus }) => {
    var currentUId = localStorage.getItem('userId');

    const apiUrl = apiUrlPrefix + 'Report/ReportMessage';
    const response = await fetch(apiUrl, {
      method: 'POST',
      credentials: 'include', // Include cookies in request
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Id: currentUId,
        Name: currentUser,
        CommunityName: communityId, //Gives the admin the community's ID
        DiscussionName: chatId,
        ReportedUsername: reportedUser,
        ReportedUserId: reportedUserId,
        ReportedMessage: reportedMessage,
        ReportLevel: reportLevel,
        ReportStatus: reportStatus
      }),
    });

    if (!response.ok) {
      if (response.status === 403) {
        //setErrorMessage('Invalid details. Ensure you add a Discussion title and at least 1 other user');
        return;
      }
      //setErrorMessage('Something went wrong. Please try again.');
      return;
    }
    return response.status; // Returns the report was sent
  };

  const handleDeleteMessage = async (message, userId) => {

    // Delete the message
    const bearerToken = localStorage.getItem('accessToken');
    try {
      const response = await fetch(apiUrlPrefix + `Discussion/RemoveMessage?discussionId=${chatId}&createdTimestamp=${message.created}&userId=${userId}`, {
        method: "Delete",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${bearerToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to send the message");
      }

    } catch (error) {
      console.error("Error sending message:", error);
      // Roll back optimistic update on error
      setMessages((prevMessages) =>
        prevMessages.filter((msg) => msg !== message)
      );
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      {messages.map((message, index) => {
        const isSameUserAsPrevious =
          index > 0 && messages[index - 1].username === message.username;

        var isSameUserAsNext = false;

        if (message.content)
          if (index < messages.length - 1) {
            isSameUserAsNext =
              messages[index + 1]?.username === message.username;
          }
        var userInformation = userList.find(u => u.id === message.username);
        const date = getPrettyDate(message.created);
        const isImage = message?.content?.includes("https://roopuwhakatau.lightsorctechnologies.com/Images/");
        return (

          <Box key={index} sx={{ mb: 1, ml: 1 }}>
            {!isSameUserAsPrevious && (

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                <Avatar
                  src={userInformation?.profilePicture}
                />
                <Typography variant="subtitle2" sx={{ color: "grey.600" }}>
                  {userInformation?.name}
                </Typography>
                <Typography variant="subtitle2" sx={{ cursor: 'pointer', display: message.username == currentUser ? 'none' : 'flex', color: "red" }} onClick={async () => {
                  var result = await blockUser({
                    reportedUserId: message?.username
                  }); if (result === 200) {
                    setReportedMessageIds((prev) => [prev, message?.content]);
                  }
                }}>
                  <BlockIcon />
                </Typography>
              </Box>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2, mb: 1 }}>
              <Paper
                sx={{
                  p: 1,
                  bgcolor: "grey.200",
                  borderRadius: "12px",
                  // 1. Change maxWidth to 33% for all screen sizes
                  maxWidth: "67%",
                  // 2. Add fit-content so it shrinks to the text size
                  width: "fit-content",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  backgroundColor: emotionStyles[message.emotion] || "grey.200"
                }}
              >
                {isImage ? (
                  <ChatImage message={message}/>
                ) : (
                  <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
                    <Linkify
                      componentDecorator={(decoratedHref, decoratedText, key) => (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={decoratedHref}
                          key={key}
                          style={{ color: '#87CEEB' }} // Using your Sky Blue!
                        >
                          {decoratedText}
                        </a>
                      )}
                    >
                      {message.content}
                    </Linkify>
                  </Typography>
                )}
              </Paper>
              <Typography variant="subtitle2" sx={{ display: message.username === currentUser ? 'none' : '', cursor: 'pointer', color: reportedMessageIds?.includes(message.content) ? 'green' : 'red' }} onClick={async () => {

                var result = await createReport({
                  reportedMessage: message.content,
                  reportedUser: message.name,
                  reportedUserId: message.username,
                  reportLevel: 1,
                  reportStatus: 1
                });

                if (result === 200) {
                  setReportedMessageIds((prev) => [prev, message.content]);
                }
              }}>{reportedMessageIds?.includes(message.content) ? <DoneIcon /> : <ReportProblemIcon color="yellow" />}</Typography>

              <Typography variant="subtitle2" sx={{ display: message.username === currentUser ? 'none' : '', cursor: 'pointer', color: adminReportedMessageIds?.includes(message.content) ? 'green' : 'red' }} onClick={async () => {
                var result = await createReport({
                  reportedMessage: message.content,
                  reportedUser: message.name,
                  reportedUserId: message.username,
                  reportLevel: 2,
                  reportStatus: 2
                });

                if (result === 200) {
                  setAdminReportedMessageIds((prev) => [prev, message.content]);
                }
              }}>{adminReportedMessageIds?.includes(message.content) ? <DoneIcon /> : <FlagIcon />}</Typography>

              {/* DELETE Message section */}
              <Typography variant="subtitle2" sx={{ display: message.username === currentUser || chatAdmins.includes(currentUser) ? '' : 'none', cursor: 'pointer', color: adminReportedMessageIds?.includes(message.content) ? 'green' : 'red' }} onClick={async () => {
                handleDeleteMessage(message, message.username)
              }
              }>{adminReportedMessageIds?.includes(message.content) ? <DoneIcon /> : <DeleteIcon />}</Typography>
            </Box>

            {
              !isSameUserAsNext ? (
                <Typography variant="subtitle2" sx={{ color: "grey.600" }}>{date === 'NaNundefined Invalid Date' ? '' : date}</Typography>
              ) : null
            }

          </Box>
        )
      })}
    </Box >
  )
};

export default ChatMessage;